import React, { useState } from 'react';
import { Dialog, Grid, TextField, Typography, withStyles } from '@material-ui/core';
import CloseBtn from '../../../common/CloseBtn';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { viewModalStyles } from '../../styles';

const EmailToSomeoneElse = ({ classes, setShowModal, showModal, sendPrescriptionNotification }) => {
    const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState(false);

    const handleChange = e => {
        setEmail(e.target.value);
    };

    const validateEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    return (
        <Dialog open={showModal} className={classes.modal}>
            <div className={classes.root} style={{ width: 500 }}>
                <div className={classes.closeBtn}>
                    <CloseBtn onClick={() => setShowModal(null)} />
                </div>
                <div className={classes.header}>
                    <p style={{ textAlign: 'center' }}>Email prescription to someone else</p>
                </div>
                <div style={{ paddingTop: 20 }}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <Typography style={{ fontSize: '1rem' }}>Email:</Typography>
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{ width: 350 }}
                                type="email"
                                value={email}
                                onChange={handleChange}
                                variant="outlined"
                                fullWidth
                                required
                                error={error}
                                helperText={error ? 'E-mail is incorrect' : ''}
                            />
                        </Grid>
                    </Grid>
                </div>
                <div className={classes.actions} style={{ width: 165, margin: '50px auto 30px auto' }}>
                    <Button
                        className={classes.cancelButton}
                        key="cancel"
                        variant="outlined"
                        onClick={() => setShowModal(null)}
                    >
                        Back
                    </Button>

                    <Button
                        disabled={confirmButtonDisabled}
                        className={classes.confirmButton}
                        onClick={async () => {
                            const isValid = validateEmail(email);
                            setError(!isValid);
                            if (!isValid) return;

                            setConfirmButtonDisabled(true);
                            await sendPrescriptionNotification(email);
                            setConfirmButtonDisabled(false);
                            setShowModal(null);
                        }}
                    >
                        Email
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

EmailToSomeoneElse.propTypes = {
    classes: PropTypes.object.isRequired,
    setShowModal: PropTypes.bool.isRequired,
    showModal: PropTypes.bool.isRequired,
    sendPrescriptionNotification: PropTypes.func.isRequired
};

export default withStyles(viewModalStyles)(EmailToSomeoneElse);
